<template>
  <div class="app-container">
    <el-form style="width:80%;margin:0 auto" label-width="120px" :rules="rules" v-if="!types">
      <el-form-item label="提现金额:" prop="name">
        <span>{{detail.money}}</span>
      </el-form-item>
      <!-- <el-form-item label="收款码:" prop="cover">
        <img :src="detail.user.qr_code" width="200px" alt="">
      </el-form-item> -->
      <el-form-item label="收款凭证:">
        <el-select
          placeholder="选择上传方式"
          clearable
          style="width: 150px;margin-right:10px;margin-bottom:10px"
          v-model="type"
        >
          <el-option v-for="item in returnList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <div v-if="type == 1">
          <UploadList width="200px" height="200px" v-model="detail.proof" :maxlength="num" :status="status" :watch="true"></UploadList>
          <img :src="qrcodeBase64" style="width: 200px;height: 200px">
          <span style="display:block">扫码上传</span>
        </div>
        <UploadList v-if="type == 2" width="200px" height="200px" v-model="detail.proof" :maxlength="num" status='all'></UploadList>
      </el-form-item>
      <el-row>
        <el-button size="small" @click="goBack">返回</el-button>
        <el-button size="small" type="primary" @click="handler" :loading="btnLoading">提交</el-button>
      </el-row>
    </el-form>
    <el-form style="width:80%;margin:0 auto" label-width="120px" :rules="rules" v-else>
      <el-form-item label="提现金额:" prop="name">
        <span>{{detail.money}}</span>
      </el-form-item>
      <!-- <el-form-item label="收款码:" prop="cover">
        <img :src="detail.user.qr_code" width="200px" alt="">
      </el-form-item> -->
      <el-form-item label="收款凭证:" prop="images">
        <UploadList width="200px" height="200px" v-model="detail.proof" :maxlength="num" :status="status" :watch="true"></UploadList>
      </el-form-item>
      <el-row>
        <el-button size="small" @click="goBack">返回</el-button>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request'
import Tinymce from "@/components/Tinymce";
import UploadOne from "@/components/UploadOne/index.vue";
import UploadList from "@/components/UploadList/index.vue";
import {descartes} from "@/utils/tool"

export default {
  components:{
    Tinymce,UploadOne,UploadList
  },
  data(){
    return{
      id:'',
      btnLoading:false,
      returnList:[{id:1,name:'手机扫码上传'},{id:2,name:'电脑上传'}],
      type:1,
      detail:{
        user:{

        },
        proof:[],
      },
      status:'watch',
      rules:{
        
      },
      qrcodeBase64:'',
      timer:null,
      types:'',
      num:6,
    }
  },
  created() {
    this.id = this.$route.query.id
    if(this.$route.query.type) {
      this.types = 'watch'
      this.getDetail()
      clearInterval(this.timer)
    }else {
      this.getDetail()
      this.getBase64()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getDetail()
      }, 3000);
    }
  },
  watch: {
    type(newVal) {
      clearInterval(this.timer)
      if(newVal == 1) {
        this.timer = setInterval(() => {
          this.getDetail()
        }, 3000);
      }
    }
  },
  methods:{
    getDetail(){
      request({
        url: "/api/backend/shop/cashOut/shopProof",
        method: "get",
        params: {id:this.id}
      }).then(response => {
          this.detail = response.data;
          if(!this.detail.proof) {
            this.detail.proof = []
          }
      });
    },
    getBase64() {
      request({
        url: "/api/common/qr_code/base64store",
        method: "get",
        params: {
          url: location.origin + '/upload?id='+this.id
        }
      }).then(response => {
        this.qrcodeBase64 = response.data;
      });
    },
    handler(){
      // if(!this.detail.user.qr_code) {
      //   this.$message({
      //     type: "error",
      //     message: "请通知用户上传收款码!"
      //   });
      //   return;
      // }
      


      if(this.detail.proof.length == 0) {
        this.$message({
          type: "error",
          message: "请上传凭证!"
        });
        return;
      }
      this.btnLoading = true
      // 上传图片的请求
      request({
        url: '/api/backend/shopcashout/addProof',
        method: 'post',
        data: {
          id:this.id,
          proof:this.detail.proof,
        }
      }).then(response => {
        this.btnLoading = false
        this.$notify({
          title: '成功',
          message: '上传成功',
          type: 'success',
          duration: 2000
        })
      }).catch((err) => {
        this.btnLoading = false
      })
      //

      this.$confirm("此操作将通过该用户的提现，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(result => {
        request({
          url: "/api/backend/shop/cashOut/agree",
          method: "get",
          params: {
            id: this.id,
          }
        })
          .then(result => {
            this.$notify.success("操作成功");
            this.$router.go(-1)
          })
          .catch(err => {
            this.$notify.error("操作失败");
          })
          .finally(() => {
            this.btnLoading = false;
          });
      })
      .catch(err => {
        this.$notify.info("已取消");
      });
    },
    goBack(){
      this.$router.go(-1)
    }
  },
  destroyed() {
　　clearInterval(this.timer); //关闭
  },
}
</script>

<style lang="scss" scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 150px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>
